export const PRODUCT_TOP_REQUEST = 'PRODUCT_TOP_REQUEST';
export const PRODUCT_TOP_SUCCESS = 'PRODUCT_TOP_SUCCESS';
export const PRODUCT_TOP_FAIL = 'PRODUCT_TOP_FAIL';

export const PRODUCT_FEATURED_REQUEST = 'PRODUCT_FEATURED_REQUEST';
export const PRODUCT_FEATURED_SUCCESS = 'PRODUCT_FEATURED_SUCCESS';
export const PRODUCT_FEATURED_FAIL = 'PRODUCT_FEATURED_FAIL';

export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAIL = 'PRODUCT_LIST_FAIL';
export const PRODUCT_LIST_APPLY_FILTER = 'PRODUCT_LIST_APPLY_FILTER';
export const PRODUCT_LIST_REMOVE_FILTER = 'PRODUCT_LIST_REMOVE_FILTER';

export const PRODUCT_DETAILS_REQUEST = 'PRODUCT_DETAILS_REQUEST';
export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_DETAILS_SUCCESS';
export const PRODUCT_DETAILS_FAIL = 'PRODUCT_DETAILS_FAIL';
